import { TimeCondition } from './TimeCondition';
import { DoctorShiftRule } from './DoctorShiftRule';

/**
 * 時間条件のバリデーション（開始時間 < 終了時間 であること）
 * @param condition TimeCondition 時間条件オブジェクト
 * @returns boolean 有効な場合true
 */
export function validateTimeCondition(condition: TimeCondition): boolean {
  const [startHour, startMin] = condition.startTime.split(':').map(Number);
  const [endHour, endMin] = condition.endTime.split(':').map(Number);

  const startMinutes = startHour * 60 + startMin;
  const endMinutes = endHour * 60 + endMin;

  return startMinutes < endMinutes;
}

/**
 * 時間条件リストのバリデーション
 * @param conditions TimeCondition[] 時間条件オブジェクトの配列
 * @returns { isValid: boolean; errors: string[] } バリデーション結果
 */
export function validateTimeConditions(conditions: TimeCondition[]): {
  isValid: boolean;
  errors: string[];
} {
  const errors: string[] = [];

  if (conditions.length === 0) {
    errors.push('時間条件を1つ以上設定してください');
  }

  conditions.forEach((condition, index) => {
    if (!validateTimeCondition(condition)) {
      errors.push(`条件${index + 1}: 終了時間は開始時間より後に設定してください`);
    }
  });

  return {
    isValid: errors.length === 0,
    errors
  };
}

/**
 * ルールが編集可能かどうか判定（論理削除されていないこと）
 * @param rule DoctorShiftRule シフトルールオブジェクト
 * @returns boolean 編集可能な場合true
 */
export function canEditRule(rule: DoctorShiftRule): boolean {
  return rule.deletedAt === undefined || rule.deletedAt === null;
}

/**
 * ルールが削除可能かどうか判定（論理削除されていないこと）
 * @param rule DoctorShiftRule シフトルールオブジェクト
 * @returns boolean 削除可能な場合true
 */
export function canDeleteRule(rule: DoctorShiftRule): boolean {
  return rule.deletedAt === undefined || rule.deletedAt === null;
}
